<template>
  <div class="checkout">
    <div class="checkout__top">
      <span class="checkout__top-title">{{ t('cart.total') }}</span> <span>€ {{ totalPrice }}</span>
    </div>
    <div class="checkout__main">
      <ui-checkbox
        v-model="isAgree"
      >
        <span>
          {{ t('docs.agreeText1') }}
          <router-link class="checkout__link" :to="translations.i18nRoute({ name: 'terms' })"> {{ t('footer.nav.terms') }} </router-link>
          {{ t('docs.agreeText2') }}
          <router-link class="checkout__link" :to="translations.i18nRoute({ name: 'policy' })"> {{ t('footer.nav.privacy') }} </router-link>
        </span>
      </ui-checkbox>
      <button
          class="checkout__button"
          @click="buyOrder"
          :disabled="!isAgree"
      >
        {{ t('buttons.checkout') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, h, ref} from "vue";
import {useCartStore} from "@/stores/cart.js";
import UiCheckbox from "@/components/ui/ui-checkbox.vue";
import translations from "@/core/helpers/translations.js";
import {ElNotification} from "element-plus";
import {useRouter} from "vue-router";
import {Orders} from "@/core/api/orders.js";
import {useAuthStore} from "@/stores/auth.js";

const {t} = useI18n()
const cartStore = useCartStore()
const authStore = useAuthStore()
const router = useRouter()

const totalPrice = computed(() => {
  return cartStore.currentOrder?.totalPrice ? cartStore.currentOrder?.totalPrice : 0
})
const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : 0
})
const userEmail = computed(() => {
  return authStore.user ? authStore.user.email : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder.uuid ? cartStore.currentOrder.uuid : ''
})
const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : null
})

const isAgree = ref(false)

const buyOrder = async () => {
  if (userBalance.value < totalPrice.value) {
    const res = await Orders.buyOrder(accessToken.value, orderUuid.value, true, false)

    if (res.errors) {
      ElNotification({
        message: res.errors[0].message,
        type: 'error'
      })
    } else {
      window.location.href = res.data.buyOrder.transaction.process.url
      // cartStore.setCurrentOrders(res.data.buyOrder.order)
      // ElNotification({
      //   message: h('div', [
      //     h('p', t('popup.successCheckout')),
      //     h(
      //       'button',
      //       {
      //         style: {
      //           marginTop: '10px',
      //           padding: '6px 12px',
      //           backgroundColor: '#FF6047',
      //           color: '#fff',
      //           border: 'none',
      //           borderRadius: '4px',
      //           cursor: 'pointer',
      //         },
      //         onClick: () => {
      //           router.push({
      //             name: 'profile',
      //             query: { page: 'profile' },
      //             params: {
      //               locale: localStorage.getItem('gce-user-locale') || 'en-gb'
      //             }
      //           })
      //         }
      //       },
      //       t('buttons.goOrders')
      //     )
      //   ]),
      //   type: 'success'
      // })
    }
  } else {
    const res = await Orders.buyOrder(accessToken.value, orderUuid.value, false, true)

    if (res.errors) {
      ElNotification({
        message: res.errors[0].message,
        type: 'error'
      })
    } else {
      const currentOrder = await Orders.getOrders("PENDING", accessToken.value, userEmail.value)
      cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)
      ElNotification({
        message: h('div', [
          h('p', t('popup.successCheckout')),
          h(
            'button',
            {
              style: {
                marginTop: '10px',
                padding: '6px 12px',
                backgroundColor: '#FF6047',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              },
              onClick: () => {
                router.push({
                  name: 'profile',
                  query: { page: 'profile' },
                  params: {
                    locale: localStorage.getItem('gce-user-locale') || 'en-gb'
                  }
                })
              }
            },
            t('buttons.goOrders')
          )
        ]),
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkout {
  margin-block: 150px;
  background: linear-gradient(180.00deg, rgb(190, 233, 252),rgb(215, 237, 255) 100%);
  border-radius: 40px;
  padding: 50px 40px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 100px;

  &__top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & span {
      font-family: Nunito, sans-serif;
      font-size: 24px;
      font-weight: 500;
      color: #1e1e1e;
    }

    &-title {
      font-family: Poppins, sans-serif !important;
      font-size: 32px !important;
      font-weight: 600 !important;
    }
  }

  &__main {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  &__link {
    color: $main;
  }

  &__button {
    cursor: pointer;
    width: 100%;
    border: 1px solid $black;
    border-radius: 4px;
    background-color: transparent;
    padding-block: 10px;
    transition: 0.2s;

    color: #2a2a2a;
    font-family: Poppins, sans-serif;
    font-size: 18px;
    font-weight: 500;

    @include hover {
      background-color: $main;
      color: $white;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: transparent;
    }

    &:disabled:hover {
      color: #2a2a2a;
    }
  }
}

@media (max-width: 1300px) {
  .checkout {
    margin-block: 40px;
  }
}

@media (max-width: 450px) {
  .checkout {
    min-width: unset;

  }
}
</style>